import { w as writable } from "./index.js";
import { T as THEME } from "./defaults.js";
const getThemeColor = () => {
  {
    return THEME.LIGHT;
  }
};
const themeStore = writable(getThemeColor());
const theme = {
  set: (value) => value === "dark" ? themeStore.set(THEME.DARK) : themeStore.set(THEME.LIGHT),
  subscribe: themeStore.subscribe
};
export {
  theme as t
};
